<template>
  <session class="page-header" :class="{ block: scrollTop > 10 }">
    <div class="container header-container">
      <div class="logo"><span>暮云宠阁｜宠一APP</span></div>
      <div class="navs">
        <span @click="smoothScrollTo('#aboutus')">关于我们</span>
        <span @click="smoothScrollTo('#intro')">功能介绍</span>
<!--        <span @click="smoothScrollTo('#download')">下载APP</span>-->
      </div>
    </div>
  </session>
  <session class="page-container">
    <slot></slot>
  </session>
  <session class="page-footer">
    <div class="container">
      <div class="footer-container">
        <div class="footer-item"><a href="/protocol/term" _target="blank">用户协议</a>&<a href="/protocol/private" _target="blank">隐私协议</a></div>
        <div class="footer-item"><span>暮云宠阁（杭州）科技有限公司 | 联系我们 chongyi_2026@163.com</span></div>
        <div class="footer-item"><span>Copyright © 2026 暮云宠阁</span><a href="https://beian.miit.gov.cn/" _target="blank">浙ICP备2026017366号</a></div>
      </div>
    </div>
  </session>
</template>

<script setup>
  import { onMounted, ref } from 'vue';

  const scrollTop = ref(0)
  onMounted(() => {
    window.addEventListener('scroll', function () {
      scrollTop.value = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
    })
  })

  const smoothScrollTo = (target) => {  
    const targetPosition = document.querySelector(target).getBoundingClientRect().top + window.pageYOffset;  
    window.scrollTo({  
      top: targetPosition,  
      behavior: "smooth"  
    });  
  } 
</script>

<style scoped lang="less">
@import "index.less";
</style>
